import React, { Component } from 'react';
import Wrapper from './components/wrapper';
import config from './common/config';
import app from './common/app';
import core from './common/core';
import { GlobalProvider } from './context/globalProvider';

let hidden, visibilityChange;
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

class App extends Component {
  componentDidMount() {
    window.addEventListener('blur', this.onBlur);
    window.addEventListener('focus', this.onFocus);
    document.addEventListener(visibilityChange, this.handleVisibilityChange);
    const disable = ['alert', 'confirm', 'prompt'];
    disable.forEach(function (action) {
      window[action] = function () {};
    });
  }

  componentWillUnmount() {
    document.removeEventListener(visibilityChange, this.handleVisibilityChange);
    window.removeEventListener('blur', this.onBlur);
    window.removeEventListener('focus', this.onFocus);
  }

  onBlur = (e) => {
    // console.log('blur', e);
    // alert('Blur')
  };

  onFocus = (e) => {
    // console.log('focus', e);
  };

  handleVisibilityChange = () => {
    // if (document[hidden]) {
    //   alert('Hidden')
    // } else {
    // }
    // alert('shown')
  };

  // onBlur = () => {
  //   console.log('blur');
  //   //
  // };

  render() {
    // return (
    //   <GlobalProvider>
    //       <Wrapper />
    //   </GlobalProvider>
    // );
    return <Wrapper />;
  }
}

export default App;
